import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getMissingBenInTemplate } from '../states/templates/selectors';

import { addNotification } from '../states/notifications/actions';

const mapState = (state) => ({
	hasMissingBenInTemplate: getMissingBenInTemplate(state),
});

const mapDispatch = (dispatch) => ({
	addNotification: (type, templateId) => dispatch(addNotification(type, { templateId })),
});

export default (WrappedComponent) => {
	const withMissingDetails = class extends Component {
		componentDidMount() {
			const { hasMissingBenInTemplate, addNotification, templateMode, templateId } = this.props;
			let key = 'missingBen';

			if (hasMissingBenInTemplate) {
				if (templateMode) {
					key = 'missingBenTemplate';
				}
				addNotification(key, templateId);
			}
		}

		render() {
			return <WrappedComponent {...this.props} />;
		}
	};

	withMissingDetails.displayName = `withMissingDetails(${
		WrappedComponent.displayName || WrappedComponent.name || 'Component'
	})`;

	withMissingDetails.propTypes = {
		hasMissingBenInTemplate: PropTypes.bool.isRequired,
		templateMode: PropTypes.bool,
		addNotification: PropTypes.func.isRequired,
		templateId: PropTypes.string,
	};

	return connect(mapState, mapDispatch)(withMissingDetails);
};
